export type LocallyDerivedTransformation =
  | MathTransformation
  | DictionaryLookupTransformation
  | ConcatTransformation;

export enum LocallyDerivedTransformationOperation {
  DICTIONARY_LOOKUP = 'dictionary_lookup',
  MATH = 'team_core_math',
  CONCAT = 'concat',
}

/**
 * Evaulate mathematical expression optionally using existing fields as variables
 */
export type MathTransformation = {
  operation: LocallyDerivedTransformationOperation.MATH;
  config: {
    additionalFields: string[];
    expression: MathExpression;
  };
};

export type ConcatTransformation = {
  operation: LocallyDerivedTransformationOperation.CONCAT;
  config: {
    additionalFields: string[];
    joinStr: string;
  };
};

/**
 * All fields must be prefixed with `@` and be present in `config.additionalFields`
 *
 * @example `(@a + @b) * @c`
 */
export type MathExpression = string;

export type DictionaryLookupTransformation<
  Key = number | string,
  Value = number | string,
> = {
  operation: LocallyDerivedTransformationOperation.DICTIONARY_LOOKUP;
  config: {
    additionalFields: string[];
    dictionary: DictionaryItem<Key, Value>[];
  };
};

export type DictionaryItem<Key = number | string, Value = number | string> = {
  key: Key | null;
  value: Value | null;
};
